import styled from 'styled-components'

export const StyledWrapper = styled.section`
  width: 100%;
`

export const StyledTable = styled.table`
  width: 100%;
`

export const StyledThead = styled.thead``

export const StyledTbody = styled.tbody``

export const StyledTh = styled.th`
  height: 60px;
  color: #798498;
  font-weight: 400;
  font-size: 16px;
  vertical-align: middle;
  padding-left: 10px;
`

export const StyledTr = styled.tr`
  background-color: #ffffff;
  box-shadow: 0px 2px 14px rgba(39, 55, 84, 0.08);
  border-radius: 8px;
  height: 44px;
`

export const StyledTd = styled.td`
  padding-left: 35px;
`
